<template>
  <VLayout :title="$t('services_temp.title')" :subtitle="$t('services_temp.subtitle')">
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";

export default {
  components: {
    VLayout,
  },
  fallbackI18n: {
    messages: {
      und: {
        services_temp: {
          title: "Services",
          subtitle: "Our services will be available soon.",
        },
      },
    },
  },
};
</script>

<style>
</style>
